import { render } from "./BaseNotificationItem.vue?vue&type=template&id=5ffb7f2c"
import script from "./BaseNotificationItem.vue?vue&type=script&lang=js"
export * from "./BaseNotificationItem.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__